import { ref, get } from 'firebase/database';
import { database } from '../firebaseConfig';
import { normalizeRole } from '../config/roles';

// Returns every user with the Agent role, sorted by name.
export const getAgents = async () => {
  const snapshot = await get(ref(database, 'users'));
  if (!snapshot.exists()) return [];
  const users = snapshot.val();
  return Object.entries(users)
    .filter(([, user]) => ['Agent', 'limited_agent'].includes(normalizeRole(user.role)))
    .map(([uid, user]) => ({
      uid,
      displayName: user.displayName || user.email || 'Unnamed agent',
      email: user.email || '',
    }))
    .sort((a, b) => a.displayName.localeCompare(b.displayName));
};

// Returns every user with the given role (for example 'TC', 'Marketing Manager', 'Local Assistant').
export const getUsersByRole = async (role) => {
  const snapshot = await get(ref(database, 'users'));
  if (!snapshot.exists()) return [];
  return Object.entries(snapshot.val())
    .filter(([, user]) => normalizeRole(user.role) === normalizeRole(role))
    .map(([uid, user]) => ({
      uid,
      displayName: user.displayName || user.email || 'Unnamed user',
      email: user.email || '',
    }));
};

// Returns one user's name, email and phone from their profile (used for the deal's agent and co-agents).
// Email is the login email the agent signs in with. Name and phone come from the profile.
export const getUserContact = async (uid) => {
  const [userSnap, profileSnap] = await Promise.all([
    get(ref(database, `users/${uid}`)),
    get(ref(database, `users/${uid}/profile`)),
  ]);
  if (!userSnap.exists()) return null;
  const user = userSnap.val();
  const profile = profileSnap.exists() ? profileSnap.val() : {};
  const nameParts = (user.displayName || '').split(' ');
  const firstName = profile.firstName || nameParts[0] || '';
  const lastName = profile.lastName || nameParts.slice(1).join(' ') || '';
  return {
    uid,
    firstName,
    lastName,
    displayName: [firstName, lastName].filter(Boolean).join(' ') || user.email || '',
    email: user.email || profile.contactEmail || '',
    phone: profile.phone || '',
    profilePhotoUrl: profile.profilePhotoUrl || '',
    celebrationPhotoUrl: profile.celebrationPhotoUrl || '',
    googleBusinessUrl: profile.googleBusinessUrl || '',
  };
};
